import React, { memo } from "react";
import type { IconProps } from "./_IconProps";

const Plus = ({ color, size }: IconProps) => (
  <svg width={size || "24px"} height={size || "24px"} viewBox="0 0 24 24">
    <g id="ic/add" fill="none" fillRule="evenodd">
      <polygon id="Shape" points="0 0 24 0 24 24 0 24" />
      <polygon
        id="Shape"
        fill={color || "#000000"}
        fillRule="nonzero"
        points="19 13 5 13 5 11 19 11"
      />
    </g>
  </svg>
);

export default memo(Plus);
